import React from 'react';
import CodeRenderer from './CodeRenderer';

interface CodeBlockProps {
    className?: string;
    children: React.ReactNode;
    startLinePosition?: number;
    endLinePosition?: number;
}

const CodeBlock: React.FC<CodeBlockProps> = ({
    className,
    children,
    startLinePosition,
    endLinePosition,
    ...props
}) => {
    // Extract language from the className (format is like "language-javascript")
    const language = className ? className.replace('language-', '') : '';

    if (language === 'json') {
        try {
            JSON.parse(String(children).trim());
        } catch {
            return (
                <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                ></span>
            );
        }
    }

    // Only use CodeRenderer for code blocks (not inline code)
    // Check if we have line position data or if start and end lines are different
    const isMultiLine =
        startLinePosition !== undefined && endLinePosition !== undefined
            ? startLinePosition !== endLinePosition
            : true; // Default to multiline if no position data provided

    if (isMultiLine) {
        return (
            <CodeRenderer
                language={language}
                value={String(children).replace(/\n$/, '')}
            />
        );
    }

    // For inline code, use the default styling
    return (
        <code className={className} {...props}>
            {children}
        </code>
    );
};

export default CodeBlock;
